import { set } from 'cerebral/operators'
import { state } from 'cerebral/tags'
import determineView from '../actions/determineView'

export default [
  determineView,
  {
    detailedView: [],
    mediaView: [set(state`media.dragging`, true)],
    noNodeSelected: [],
    other: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/beginDragMedia.js